// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZSU2","selected":"styles_selected__Jlg-u"};